import { render, staticRenderFns } from "./QnaDetail.vue?vue&type=template&id=8ec1c98a"
import script from "./QnaDetail.vue?vue&type=script&lang=js"
export * from "./QnaDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports